import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SvgIconsModule} from "@ngneat/svg-icon";
import {asDocumentDuplicateOutlineIcon} from "./svg/outline-document-duplicate";
import {asDocumentTextOutlineIcon} from "./svg/outline-document-text";
import {asEnvelopeOutlineIcon} from "./svg/outline-envolope";
import {asFolderOutlineIcon} from "./svg/outline-folder";
import {asHomeOutlineIcon} from "./svg/outline-home";
import {asUserOutlineIcon} from "./svg/outline-user";
import {asBedOutlineIcon} from "./svg/outline-bed";
import {asCurrencyEuroIcon} from "./svg/outline-currency-euro";
import {asWrenchScrewdriverOutlineIcon} from "./svg/outline-wrench-screwdriver";
import {asEllipsisVerticalOutlineIcon} from "./svg/outline-ellipsis-vertical";
import {asReceiptRefundOutlineIcon} from "./svg/outline-receipt-refund";
import {asSolidJpgIcon} from "./svg/solid-jpg";
import {asSolidPdfIcon} from "./svg/solid-pdf";
import {asSolidXlsxIcon} from "./svg/solid-xlsx";
import {asArrowDownTrayMiniIcon} from "./svg/mini-arrow-down-tray";
import {asTrashOutlineIcon} from "./svg/outline-trash";
import {asExclamationCircleIcon} from "./svg/solid-exclamation-circle";
import {asCheckBadgeSolidIcon} from "./svg/solid-check-badge";
import {asXMarkMiniIcon} from "./svg/mini-x-mark";
import {asCheckMiniIcon} from "./svg/mini-check";
import {asImageAddOutlineIcon} from "./svg/outline-image-add";
import {asEyeOutlineIcon} from "./svg/outline-eye";
import {asAmitelAvatarIcon} from "./svg/amitel-avatar";
import {asPaperClipOutlineIcon} from "./svg/outline-paper-clip";
import {asMoonOutlineIcon} from "./svg/outline-moon";
import {asSunOutlineIcon} from "./svg/outline-sun";
import {asSolidMenuIcon} from "./svg/solid-menu";
import {asSolidXMarkIcon} from "./svg/solid-x-mark";
import {asCreditCardOutlineIcon} from "./svg/outline-credit-card";


@NgModule({
  exports: [
    SvgIconsModule
  ],
  imports: [
    CommonModule,
    SvgIconsModule.forRoot({
      sizes: {
        xs: '16px',
        sm: '20px',
        md: '24px',
        lg: '28px',
        xl: '32px',
        xxl: '40px',
        xxxl: '64px',
        xxxxl: '128px',
      },
      defaultSize: 'md',
      icons: [
        asSolidJpgIcon,
        asSolidPdfIcon,
        asSolidMenuIcon,
        asSolidXlsxIcon,
        asXMarkMiniIcon,
        asCheckMiniIcon,
        asSolidXMarkIcon,
        asBedOutlineIcon,
        asSunOutlineIcon,
        asEyeOutlineIcon,
        asUserOutlineIcon,
        asHomeOutlineIcon,
        asMoonOutlineIcon,
        asAmitelAvatarIcon,
        asTrashOutlineIcon,
        asCurrencyEuroIcon,
        asFolderOutlineIcon,
        asEnvelopeOutlineIcon,
        asImageAddOutlineIcon,
        asCheckBadgeSolidIcon,
        asPaperClipOutlineIcon,
        asExclamationCircleIcon,
        asCreditCardOutlineIcon,
        asArrowDownTrayMiniIcon,
        asDocumentTextOutlineIcon,
        asReceiptRefundOutlineIcon,
        asEllipsisVerticalOutlineIcon,
        asDocumentDuplicateOutlineIcon,
        asWrenchScrewdriverOutlineIcon,
      ]
    })
  ]
})
export class IconModule {
}
